import { render, staticRenderFns } from "./StatusSelect.vue?vue&type=template&id=65c3bf99"
import script from "./StatusSelect.vue?vue&type=script&lang=ts"
export * from "./StatusSelect.vue?vue&type=script&lang=ts"
import style0 from "./StatusSelect.vue?vue&type=style&index=0&id=65c3bf99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports